module.exports = __webpack_public_path__ + "img/638.31d7e57d.jpg";